export type Polygon = number[][][];
export type MultiPolygon = Polygon[];

export interface IProperties {
    name?: string;
    tags?: string[];
    type?: string;
    code?: string;
    externalId?: string;
    isStopOver?: boolean;
    color?: string;
    organizationId?: string;
    maxSpeed?: {
        enabled: boolean;
        value: number;
    };
}

export interface IGeometry {
    type: string;
    coordinates: MultiPolygon | Polygon;
}

export interface ICreateZoneDto {
    type: string;
    geometry: IGeometry;
    properties: IProperties;
}
